module.exports = __webpack_public_path__ + "static/media/n2.3edc1dca.png";